export default "__VITE_ASSET__CVmJMAbs__"